export const writableStore = (store) => {
    return store;
};
//# sourceMappingURL=ReadonlyStore.js.map